// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file common.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * Enum for filter types
 *
 * @generated from enum cuda_learning.FilterType
 */
export enum FilterType {
  /**
   * @generated from enum value: FILTER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILTER_TYPE_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: FILTER_TYPE_GRAYSCALE = 2;
   */
  GRAYSCALE = 2,

  /**
   * @generated from enum value: FILTER_TYPE_BLUR = 3;
   */
  BLUR = 3,

  /**
   * @generated from enum value: FILTER_TYPE_MODEL_INFERENCE = 4;
   */
  MODEL_INFERENCE = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(FilterType)
proto3.util.setEnumType(FilterType, "cuda_learning.FilterType", [
  { no: 0, name: "FILTER_TYPE_UNSPECIFIED" },
  { no: 1, name: "FILTER_TYPE_NONE" },
  { no: 2, name: "FILTER_TYPE_GRAYSCALE" },
  { no: 3, name: "FILTER_TYPE_BLUR" },
  { no: 4, name: "FILTER_TYPE_MODEL_INFERENCE" },
]);

/**
 * Enum for blur types
 *
 * @generated from enum cuda_learning.BlurType
 */
export enum BlurType {
  /**
   * @generated from enum value: BLUR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BLUR_TYPE_GAUSSIAN = 1;
   */
  GAUSSIAN = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(BlurType)
proto3.util.setEnumType(BlurType, "cuda_learning.BlurType", [
  { no: 0, name: "BLUR_TYPE_UNSPECIFIED" },
  { no: 1, name: "BLUR_TYPE_GAUSSIAN" },
]);

/**
 * Enum for border handling modes
 *
 * @generated from enum cuda_learning.BorderMode
 */
export enum BorderMode {
  /**
   * @generated from enum value: BORDER_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BORDER_MODE_CLAMP = 1;
   */
  CLAMP = 1,

  /**
   * @generated from enum value: BORDER_MODE_REFLECT = 2;
   */
  REFLECT = 2,

  /**
   * @generated from enum value: BORDER_MODE_WRAP = 3;
   */
  WRAP = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(BorderMode)
proto3.util.setEnumType(BorderMode, "cuda_learning.BorderMode", [
  { no: 0, name: "BORDER_MODE_UNSPECIFIED" },
  { no: 1, name: "BORDER_MODE_CLAMP" },
  { no: 2, name: "BORDER_MODE_REFLECT" },
  { no: 3, name: "BORDER_MODE_WRAP" },
]);

/**
 * Enum for accelerator types
 *
 * @generated from enum cuda_learning.AcceleratorType
 */
export enum AcceleratorType {
  /**
   * @generated from enum value: ACCELERATOR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCELERATOR_TYPE_CUDA = 1;
   */
  CUDA = 1,

  /**
   * @generated from enum value: ACCELERATOR_TYPE_CPU = 2;
   */
  CPU = 2,

  /**
   * @generated from enum value: ACCELERATOR_TYPE_OPENCL = 3;
   */
  OPENCL = 3,

  /**
   * @generated from enum value: ACCELERATOR_TYPE_VULKAN = 4;
   */
  VULKAN = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(AcceleratorType)
proto3.util.setEnumType(AcceleratorType, "cuda_learning.AcceleratorType", [
  { no: 0, name: "ACCELERATOR_TYPE_UNSPECIFIED" },
  { no: 1, name: "ACCELERATOR_TYPE_CUDA" },
  { no: 2, name: "ACCELERATOR_TYPE_CPU" },
  { no: 3, name: "ACCELERATOR_TYPE_OPENCL" },
  { no: 4, name: "ACCELERATOR_TYPE_VULKAN" },
]);

/**
 * Enum for grayscale conversion algorithms
 *
 * @generated from enum cuda_learning.GrayscaleType
 */
export enum GrayscaleType {
  /**
   * @generated from enum value: GRAYSCALE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ITU-R BT.601 (SDTV): Y = 0.299R + 0.587G + 0.114B
   *
   * @generated from enum value: GRAYSCALE_TYPE_BT601 = 1;
   */
  BT601 = 1,

  /**
   * ITU-R BT.709 (HDTV): Y = 0.2126R + 0.7152G + 0.0722B
   *
   * @generated from enum value: GRAYSCALE_TYPE_BT709 = 2;
   */
  BT709 = 2,

  /**
   * Simple average: Y = (R + G + B) / 3
   *
   * @generated from enum value: GRAYSCALE_TYPE_AVERAGE = 3;
   */
  AVERAGE = 3,

  /**
   * Lightness: Y = (max(R,G,B) + min(R,G,B)) / 2
   *
   * @generated from enum value: GRAYSCALE_TYPE_LIGHTNESS = 4;
   */
  LIGHTNESS = 4,

  /**
   * Luminosity: Y = 0.21R + 0.72G + 0.07B (similar to BT709)
   *
   * @generated from enum value: GRAYSCALE_TYPE_LUMINOSITY = 5;
   */
  LUMINOSITY = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(GrayscaleType)
proto3.util.setEnumType(GrayscaleType, "cuda_learning.GrayscaleType", [
  { no: 0, name: "GRAYSCALE_TYPE_UNSPECIFIED" },
  { no: 1, name: "GRAYSCALE_TYPE_BT601" },
  { no: 2, name: "GRAYSCALE_TYPE_BT709" },
  { no: 3, name: "GRAYSCALE_TYPE_AVERAGE" },
  { no: 4, name: "GRAYSCALE_TYPE_LIGHTNESS" },
  { no: 5, name: "GRAYSCALE_TYPE_LUMINOSITY" },
]);

/**
 * W3C Trace Context for distributed tracing
 *
 * @generated from message cuda_learning.TraceContext
 */
export class TraceContext extends Message<TraceContext> {
  /**
   * @generated from field: string traceparent = 1;
   */
  traceparent = "";

  /**
   * @generated from field: string tracestate = 3;
   */
  tracestate = "";

  constructor(data?: PartialMessage<TraceContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.TraceContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traceparent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tracestate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TraceContext {
    return new TraceContext().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TraceContext {
    return new TraceContext().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TraceContext {
    return new TraceContext().fromJsonString(jsonString, options);
  }

  static equals(a: TraceContext | PlainMessage<TraceContext> | undefined, b: TraceContext | PlainMessage<TraceContext> | undefined): boolean {
    return proto3.util.equals(TraceContext, a, b);
  }
}

/**
 * Gaussian blur parameters
 *
 * @generated from message cuda_learning.GaussianBlurParameters
 */
export class GaussianBlurParameters extends Message<GaussianBlurParameters> {
  /**
   * @generated from field: int32 kernel_size = 1 [json_name = "kernel_size"];
   */
  kernelSize = 0;

  /**
   * @generated from field: float sigma = 3;
   */
  sigma = 0;

  /**
   * @generated from field: cuda_learning.BorderMode border_mode = 5 [json_name = "border_mode"];
   */
  borderMode = BorderMode.UNSPECIFIED;

  /**
   * @generated from field: bool separable = 7;
   */
  separable = false;

  constructor(data?: PartialMessage<GaussianBlurParameters>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GaussianBlurParameters";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kernel_size", jsonName: "kernel_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "sigma", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "border_mode", jsonName: "border_mode", kind: "enum", T: proto3.getEnumType(BorderMode) },
    { no: 7, name: "separable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GaussianBlurParameters {
    return new GaussianBlurParameters().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GaussianBlurParameters {
    return new GaussianBlurParameters().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GaussianBlurParameters {
    return new GaussianBlurParameters().fromJsonString(jsonString, options);
  }

  static equals(a: GaussianBlurParameters | PlainMessage<GaussianBlurParameters> | undefined, b: GaussianBlurParameters | PlainMessage<GaussianBlurParameters> | undefined): boolean {
    return proto3.util.equals(GaussianBlurParameters, a, b);
  }
}

/**
 * Model inference parameters for AI/ML object detection
 *
 * @generated from message cuda_learning.ModelInferenceParameters
 */
export class ModelInferenceParameters extends Message<ModelInferenceParameters> {
  /**
   * @generated from field: string model_id = 1 [json_name = "model_id"];
   */
  modelId = "";

  /**
   * @generated from field: float confidence_threshold = 3 [json_name = "confidence_threshold"];
   */
  confidenceThreshold = 0;

  constructor(data?: PartialMessage<ModelInferenceParameters>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ModelInferenceParameters";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "model_id", jsonName: "model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confidence_threshold", jsonName: "confidence_threshold", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ModelInferenceParameters {
    return new ModelInferenceParameters().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ModelInferenceParameters {
    return new ModelInferenceParameters().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ModelInferenceParameters {
    return new ModelInferenceParameters().fromJsonString(jsonString, options);
  }

  static equals(a: ModelInferenceParameters | PlainMessage<ModelInferenceParameters> | undefined, b: ModelInferenceParameters | PlainMessage<ModelInferenceParameters> | undefined): boolean {
    return proto3.util.equals(ModelInferenceParameters, a, b);
  }
}

/**
 * Filter parameter definition
 *
 * @generated from message cuda_learning.FilterParameter
 */
export class FilterParameter extends Message<FilterParameter> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string type = 5;
   */
  type = "";

  /**
   * @generated from field: repeated string options = 7;
   */
  options: string[] = [];

  /**
   * @generated from field: string default_value = 9 [json_name = "default_value"];
   */
  defaultValue = "";

  /**
   * @generated from field: map<string, string> metadata = 11;
   */
  metadata: { [key: string]: string } = {};

  constructor(data?: PartialMessage<FilterParameter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.FilterParameter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "options", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "default_value", jsonName: "default_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FilterParameter {
    return new FilterParameter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FilterParameter {
    return new FilterParameter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FilterParameter {
    return new FilterParameter().fromJsonString(jsonString, options);
  }

  static equals(a: FilterParameter | PlainMessage<FilterParameter> | undefined, b: FilterParameter | PlainMessage<FilterParameter> | undefined): boolean {
    return proto3.util.equals(FilterParameter, a, b);
  }
}

/**
 * Filter definition with supported accelerators
 *
 * @generated from message cuda_learning.FilterDefinition
 */
export class FilterDefinition extends Message<FilterDefinition> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: repeated cuda_learning.FilterParameter parameters = 5;
   */
  parameters: FilterParameter[] = [];

  /**
   * @generated from field: repeated cuda_learning.AcceleratorType supported_accelerators = 7 [json_name = "supported_accelerators"];
   */
  supportedAccelerators: AcceleratorType[] = [];

  constructor(data?: PartialMessage<FilterDefinition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.FilterDefinition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "parameters", kind: "message", T: FilterParameter, repeated: true },
    { no: 7, name: "supported_accelerators", jsonName: "supported_accelerators", kind: "enum", T: proto3.getEnumType(AcceleratorType), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FilterDefinition {
    return new FilterDefinition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FilterDefinition {
    return new FilterDefinition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FilterDefinition {
    return new FilterDefinition().fromJsonString(jsonString, options);
  }

  static equals(a: FilterDefinition | PlainMessage<FilterDefinition> | undefined, b: FilterDefinition | PlainMessage<FilterDefinition> | undefined): boolean {
    return proto3.util.equals(FilterDefinition, a, b);
  }
}

/**
 * Library capabilities (shared metadata)
 *
 * @generated from message cuda_learning.LibraryCapabilities
 */
export class LibraryCapabilities extends Message<LibraryCapabilities> {
  /**
   * @generated from field: string api_version = 1 [json_name = "api_version"];
   */
  apiVersion = "";

  /**
   * @generated from field: string library_version = 3 [json_name = "library_version"];
   */
  libraryVersion = "";

  /**
   * @generated from field: repeated cuda_learning.FilterDefinition filters = 5;
   */
  filters: FilterDefinition[] = [];

  /**
   * @generated from field: bool supports_streaming = 11 [json_name = "supports_streaming"];
   */
  supportsStreaming = false;

  /**
   * @generated from field: string build_date = 13 [json_name = "build_date"];
   */
  buildDate = "";

  /**
   * @generated from field: string build_commit = 15 [json_name = "build_commit"];
   */
  buildCommit = "";

  constructor(data?: PartialMessage<LibraryCapabilities>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.LibraryCapabilities";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "library_version", jsonName: "library_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "filters", kind: "message", T: FilterDefinition, repeated: true },
    { no: 11, name: "supports_streaming", jsonName: "supports_streaming", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "build_date", jsonName: "build_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "build_commit", jsonName: "build_commit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LibraryCapabilities {
    return new LibraryCapabilities().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LibraryCapabilities {
    return new LibraryCapabilities().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LibraryCapabilities {
    return new LibraryCapabilities().fromJsonString(jsonString, options);
  }

  static equals(a: LibraryCapabilities | PlainMessage<LibraryCapabilities> | undefined, b: LibraryCapabilities | PlainMessage<LibraryCapabilities> | undefined): boolean {
    return proto3.util.equals(LibraryCapabilities, a, b);
  }
}

/**
 * Static image metadata (shared across services)
 *
 * @generated from message cuda_learning.StaticImage
 */
export class StaticImage extends Message<StaticImage> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string display_name = 3 [json_name = "display_name"];
   */
  displayName = "";

  /**
   * @generated from field: string path = 5;
   */
  path = "";

  /**
   * @generated from field: bool is_default = 7 [json_name = "is_default"];
   */
  isDefault = false;

  constructor(data?: PartialMessage<StaticImage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StaticImage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", jsonName: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_default", jsonName: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StaticImage {
    return new StaticImage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StaticImage {
    return new StaticImage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StaticImage {
    return new StaticImage().fromJsonString(jsonString, options);
  }

  static equals(a: StaticImage | PlainMessage<StaticImage> | undefined, b: StaticImage | PlainMessage<StaticImage> | undefined): boolean {
    return proto3.util.equals(StaticImage, a, b);
  }
}

/**
 * Static video metadata (shared across services)
 *
 * @generated from message cuda_learning.StaticVideo
 */
export class StaticVideo extends Message<StaticVideo> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string display_name = 3 [json_name = "display_name"];
   */
  displayName = "";

  /**
   * @generated from field: string path = 5;
   */
  path = "";

  /**
   * @generated from field: string preview_image_path = 7 [json_name = "preview_image_path"];
   */
  previewImagePath = "";

  /**
   * @generated from field: bool is_default = 9 [json_name = "is_default"];
   */
  isDefault = false;

  constructor(data?: PartialMessage<StaticVideo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StaticVideo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", jsonName: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "preview_image_path", jsonName: "preview_image_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_default", jsonName: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StaticVideo {
    return new StaticVideo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StaticVideo {
    return new StaticVideo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StaticVideo {
    return new StaticVideo().fromJsonString(jsonString, options);
  }

  static equals(a: StaticVideo | PlainMessage<StaticVideo> | undefined, b: StaticVideo | PlainMessage<StaticVideo> | undefined): boolean {
    return proto3.util.equals(StaticVideo, a, b);
  }
}

